import type { LegendPlacementSide } from "./types";

// Reorder this array to change placement priority. The first side that has
// enough room around the bounding box wins; if none fit, the legend is
// anchored inside the page as a fallback so it never gets cropped.
export const LEGEND_PLACEMENT_PRIORITY: readonly LegendPlacementSide[] = [
  "right",
  "below",
  "left",
  "above",
];
